import {
  CONFIRM,
  SET_ID,
  SET_DRAFT,
  SET_PRODUCT,
  SET_STATUS,
  SET_DUPLICATED_JOB_DRAFT,
  SET_UPGRADES,
} from '../../actions/draft/draft'
import { initialState } from '..'
import type { JobPostingProduct } from '../entitlement/entitlement'
import type { ContactInformation, JobStatus, Location, Logo, Video, CustomFields } from '../jobs/jobs'
import { RemoteWork } from '../../../service/util/master-data/masterdata'

export type NumberRange = {
  lower: number | undefined,
  upper: number | undefined,
}

export type ApplyViaJobBoard = {
  applyOption?: 'ByEmail' // presentational
  via: 'jobboard'
  firstName: string
  lastName: string
  emailAddress: string
}

export type ApplyViaExternal = {
  applyOption?: 'ByExternalUrl' // presentational
  via: 'external'
  url: string
}

export type ApplyViaEasyApply = {
  applyOption?: 'ByEasyApply' // presentational
  via: 'easyapply'
}

export type ApplyVia = ApplyViaJobBoard | ApplyViaExternal | ApplyViaEasyApply

export type classifiedFunctionGroup = {
  classified: {
    value: string
    label: string
  }
}

export type unclassifiedFunctionGroup = {
  unclassified: string
}

export type FunctionGroupType = classifiedFunctionGroup | unclassifiedFunctionGroup

export type SalaryTypeType = 'hourly' | 'monthly' | 'yearly' | 'unspecified'

export type DownStreamSalaryType = {
  lower: number,
  upper: number,
  type?: SalaryTypeType
}

// this type is specifically tailored to the requirements of the form
export type Draft = {
  content: {
    title: string,
    description: string,
    functionGroup: FunctionGroupType,
    jobCategories: string[],
    industryCategories: string[],
  },
  criteria: {
    educationLevels: string[],
    careerLevels: string[],
    requirements?: string,
  },
  contract: {
    contractTypes: string[],
    workingHours: NumberRange,
    salary?: DownStreamSalaryType,
    remoteWork?: RemoteWork | ''
  },
  publicationPeriod: {
    start: Date | undefined,
    end: Date | undefined,
  },
  location: Location,
  applyVia: ApplyVia,
  company: {
    name: string,
    companyType: string,
    availableNames: string[], // presentational
    description?: string,
    huisstijl?: any,
    website?: string | undefined,
  },
  logo?: Logo,
  contactInformation?: ContactInformation,
  customFields?: CustomFields,
  video?: Video,
}

export type DraftStoreType = {
  draft: Draft,
  id: string,
  product: JobPostingProduct,
  upgrades?: any[],
  isConfirmed: boolean,
  status: JobStatus,
  contract?: any,
}

const reducer = (state: DraftStoreType | undefined, { payload, type }: any): DraftStoreType => {
  if (!state) return initialState.draft

  if (type === CONFIRM) {
    return {
      ...state,
      ...{ isConfirmed: true },
    }
  }

  if (type === SET_ID) {
    return {
      ...state,
      ...{ id: payload },
    }
  }

  if (type === SET_DRAFT) {
    return {
      ...state,
      ...{ draft: payload },
    }
  }

  if (type === SET_PRODUCT) {
    return {
      ...state,
      ...{ product: payload },
    }
  }

  if (type === SET_UPGRADES) {
    return {
      ...state,
      upgrades: payload,
    }
  }

  if (type === SET_STATUS) {
    return {
      ...state,
      ...{ status: payload },
    }
  }

  if (type === SET_DUPLICATED_JOB_DRAFT) {
    return {
      ...state,
      id: payload.id,
      draft: payload.draft,
      product: payload.product,
      status: payload.status,
      upgrades: payload.upgrades,
    }
  }

  return state
}

export default reducer
